import { render, staticRenderFns } from "./Editors.vue?vue&type=template&id=6ebf38c4&"
import script from "./Editors.vue?vue&type=script&lang=js&"
export * from "./Editors.vue?vue&type=script&lang=js&"
import style0 from "./Editors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports